import React, { useContext, useEffect, useRef, useState } from "react"
import tw from "twin.macro"
import { CouponsProps } from "./Coupons.d"
import Icon from "../../atoms/Icon"
import AliceCarousel from "react-alice-carousel"
import "react-alice-carousel/lib/alice-carousel.css"
import { LanguageContext } from "../../../contexts/Language"
import Coupon from "./Coupon"
import moment from "moment"

/**
 *
 * @author Cody
 * @summary
 *
 *
 */

const Coupons: React.FC<CouponsProps> = ({
  coupons,
  showTitle = true,
  fromArticle = false,
  fromParts = false,
  ...remainingProps
}) => {
  const { _ } = useContext(LanguageContext)
  const parentContainer = useRef(null)
  const responsive = fromArticle
    ? {
        0: { items: 1 },
        829: { items: 2 },
        1023: { items: 1 },
        1440: { items: 1 },
      }
    : {
        0: { items: 1 },
        711: { items: 2 },
        1023: { items: 3 },
        1440: { items: 4 },
      }
  const [items, setItems] = useState([])

  const getDisclaimerParentPosition = (): { left: number; right: number } => {
    if (window?.innerWidth < 640) return { left: null, right: null }

    const parentContainerRect =
      parentContainer?.current?.getBoundingClientRect()

    const parentContainerStyle = getComputedStyle(parentContainer?.current)
    const paddingLeft =
      Number(parentContainerStyle?.paddingLeft?.replace("px", "")) + 10
    const paddingRight =
      Number(parentContainerStyle?.paddingRight?.replace("px", "")) + 10

    return {
      left: parentContainerRect?.left + paddingLeft,
      right: parentContainerRect?.right - paddingRight,
    }
  }

  useEffect(() => {
    const disclaimerParentPosition = getDisclaimerParentPosition()
    const today = moment()
    setItems(
      coupons
        ?.map((coupon: any, index: number) => {
          const startDate =
            coupon.starts && moment(coupon.starts).startOf("day")
          const endDate = coupon.expires && moment(coupon.expires).endOf("day")
          if (!today.isBetween(startDate, endDate)) {
            return null
          } else {
            return (
              <Coupon
                coupon={coupon}
                index={index}
                parentLeft={disclaimerParentPosition.left}
                parentRight={disclaimerParentPosition.right}
              />
            )
          }
        })
        ?.filter(coupon => coupon),
    )
  }, [coupons])

  const renderPrevButton = ({ isDisabled }) => {
    return (
      <button
        css={[
          tw`absolute left-2 top-[45%] -translate-y-1/2 z-50 flex justify-center items-center cursor-pointer w-16 h-10 bg-gunmetal rounded-full transition-all hover:bg-gunmetalHover focus-visible:(bg-gunmetalHover)`,
          tw`lg:(-left-10)`,
          isDisabled ? tw`hidden` : tw`flex`,
        ]}
      >
        <Icon.Chevron direction="left" color="white" css={[tw`h-5`]} />
      </button>
    )
  }

  const renderNextButton = ({ isDisabled }) => {
    return (
      <button
        css={[
          tw`absolute right-2 top-[45%] -translate-y-1/2 z-50 flex justify-center items-center cursor-pointer w-16 h-10 bg-gunmetal rounded-full transition-all hover:(bg-gunmetalHover) focus-visible:(bg-gunmetalHover)`,
          tw`lg:(-right-10)`,
          isDisabled ? tw`hidden` : tw`flex`,
        ]}
      >
        <Icon.Chevron direction="right" color="white" css={[tw`h-5`]} />
      </button>
    )
  }

  return (
    <section
      css={[
        tw`pt-20 sm:(px-4)`,

        tw`md:(px-6) bg-gradient-to-t from-gray-50`,
        fromParts && tw`min-h-[925px] md:(min-h-[925px])`,
        fromArticle &&
          tw`bg-none pt-10 border-t border-gray-400 lg:(border-none)`,
      ]}
      {...remainingProps}
    >
      {showTitle && (
        <h2
          css={[
            tw`text-2xl font-light pl-6 pb-6 tracking-widest md:(text-3xl)`,
          ]}
        >
          {_("Coupons")}
        </h2>
      )}
      <div
        css={[
          tw`max-w-7xl mx-auto`,
          fromArticle && tw` max-w-7xl lg:max-w-[500px]`,
        ]}
      >
        <div
          css={[
            tw`flex overflow-y-visible pl-0`,
            tw`sm:(px-10)`,
            fromArticle && tw`sm:px-6`,
          ]}
          ref={parentContainer}
        >
          <AliceCarousel
            mouseTracking
            items={items}
            disableDotsControls
            responsive={responsive}
            paddingLeft={
              items?.length < 3 &&
              parentContainer?.current?.getBoundingClientRect().width > 1024
                ? 100
                : 0
            }
            paddingRight={
              items?.length < 3 &&
              parentContainer?.current?.getBoundingClientRect().width > 1024
                ? 100
                : 0
            }
            controlsStrategy="default"
            renderPrevButton={renderPrevButton}
            renderNextButton={renderNextButton}
          />
        </div>
      </div>
    </section>
  )
}

export default Coupons
